export default __webpack_public_path__ + "images/ftm_4e9ab3.svg";